import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReorder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "icon/reorder" }), /* @__PURE__ */ _jsx("g", {
		id: "Symbols",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "icon/reorder",
			fill: "#000000",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Group",
				transform: "translate(4.000000, 4.000000)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle",
						x: 0,
						y: 8,
						width: 16,
						height: 1
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy",
						x: 0,
						y: 5,
						width: 16,
						height: 1
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy-2",
						x: 0,
						y: 11,
						width: 16,
						height: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M7.82842712,3.35287353e-14 L10.6568542,2.82842712 L5,2.82842712 L7.82842712,3.35287353e-14 Z",
						id: "Combined-Shape"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M7.82842712,14 L10.6568542,16.8284271 L5,16.8284271 L7.82842712,14 Z",
						id: "Combined-Shape-Copy",
						transform: "translate(7.828427, 15.414214) scale(1, -1) translate(-7.828427, -15.414214) "
					})
				]
			}), /* @__PURE__ */ _jsx("path", { d: "M14.6568542,18 L11.8284271,20.8284271 L9,18 L14.6568542,18 Z M20,15 L20,16 L4,16 L4,15 L20,15 Z M20,12 L20,13 L4,13 L4,12 L20,12 Z M20,9 L20,10 L4,10 L4,9 L20,9 Z M11.8284271,4 L14.6568542,6.82842712 L9,6.82842712 L11.8284271,4 Z" })]
		})
	})]
});
export default SvgReorder;
